import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Col, Form, Input, Row } from "antd";
import { observer } from "mobx-react-lite";
import { useStores } from "../../../../../../../store/root.js";
import { spacing } from "../../../../../../../styles/spacing.js";
import { mergeStyles } from "../../../../../../../util/style.js";
import { getPathInfo } from "../../../../../../../util/template/form.js";
import { getFormPropsByLanguage, getTranslationFlagElementStyle, hasTranslationFlagsChanged, onTranslationValueChange } from "../../../../../../../util/translation.js";
import { LanguageIcon } from "../language-icon-addon/language-icon.js";
const TranslationTextAreaFormFieldEntry = observer(({ lang, flexPathConfig, customPlaceholder, formProps, textAreaProps })=>{
    const form = Form.useFormInstance();
    const { rcbUserSettingsStore: { settings: { translationSettings } } } = useStores();
    const inputInfo = getPathInfo(flexPathConfig, lang);
    const { style } = getFormPropsByLanguage(lang, translationSettings);
    return /*#__PURE__*/ _jsx(Form.Item, {
        shouldUpdate: (prev, next)=>hasTranslationFlagsChanged(prev, next, inputInfo.flagNamePath),
        noStyle: true,
        children: ()=>{
            const flagStyle = getTranslationFlagElementStyle(form, inputInfo.flagNamePath);
            return /*#__PURE__*/ _jsxs(Row, {
                gutter: [
                    10,
                    10
                ],
                style: {
                    ...style,
                    paddingTop: spacing.layout.content.paddingSmall,
                    flexFlow: "row"
                },
                children: [
                    /*#__PURE__*/ _jsx(Col, {
                        flex: 1,
                        children: /*#__PURE__*/ _jsx(Form.Item, {
                            name: inputInfo.namePath,
                            noStyle: true,
                            ...formProps,
                            children: /*#__PURE__*/ _jsx(Input.TextArea, {
                                placeholder: textAreaProps?.placeholder || customPlaceholder?.(lang),
                                ...textAreaProps,
                                style: mergeStyles(textAreaProps.style, flagStyle),
                                onChange: ()=>onTranslationValueChange(form, inputInfo.flagNamePath, lang)
                            })
                        })
                    }),
                    /*#__PURE__*/ _jsx(Col, {
                        flex: "0",
                        children: /*#__PURE__*/ _jsx(LanguageIcon, {
                            lang: lang,
                            flexPathConfig: flexPathConfig
                        })
                    })
                ]
            }, inputInfo.key);
        }
    }, `${inputInfo.key}-wrapper`);
});
export { TranslationTextAreaFormFieldEntry };
